import { useSWR } from '@tiger/swr';
import { Button } from 'antd';
import qrcode from 'qrcode';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import Toast from 'components/Toast';
import Track from 'components/Track';
import API from 'utils/API';
import http from 'utils/http';
import { LocationStatesSuccessNextUrl } from './types';

const Bind: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as LocationStatesSuccessNextUrl | null;
    const verifyToken = (location.state as { verify_token: string } | null)?.verify_token;

    const { isLoading, error, data, mutate } = useSWR(`${API.OAUTH.otp.genkey()}-${verifyToken}`, {
        fetcher: () => {
            return http.post(API.OAUTH.otp.genkey(), {
                verify_token: verifyToken
            });
        },
        errorRetryCount: 0,
        immutable: true, // 每个 verify_token 应当只有一个有效请求，多次请求会出错
        dataChain: resp => resp.data,
        errorChain: err => {
            if (err.error_code === 11084) {
                Toast.show(err);
                navigate('../1', { replace: true });
            } else {
                throw err;
            }
        }
    });

    const {
        error: qrcodeError,
        isLoading: qrcodeIsLoading,
        data: qrcodeBase64,
        mutate: qrcodeMutate
    } = useSWR(data ? `otp-get-qrcode-${JSON.stringify(data)}` : null, {
        fetcher: () => {
            const { name, key, uuid } = data;

            return qrcode.toDataURL(`otpauth://totp/Tiger%20App:${name}?secret=${key}&uuid=${uuid}`);
        },
        immutable: true
    });

    const render = () => {
        if (isLoading || qrcodeIsLoading) {
            return <Loading />;
        }

        if ((error && !data) || qrcodeError) {
            return (
                <ErrorBox
                    error={error || qrcodeError}
                    onClick={() => {
                        error && mutate();
                        qrcodeError && qrcodeMutate();
                    }}
                />
            );
        }

        return (
            <>
                <div>
                    <img src={qrcodeBase64} alt="qrcode" />
                </div>
                <p>
                    {__('打开TradeUP Authenticator App，并点击“扫描二维码进行关联”；')}
                    <br />
                    {__('使⽤手机上的相机扫描左侧二维码进行关联。')}
                </p>
                <div>
                    <CardButtonWrap>
                        <Track eventModel="安全中心" eventType="两步验证_开启" eventName="两步验证开启_上一步">
                            <Button
                                size="large"
                                block
                                onClick={() => {
                                    navigate(-1);
                                }}>
                                {__('上一步')}
                            </Button>
                        </Track>
                        <Track eventModel="安全中心" eventType="两步验证_开启" eventName="两步验证开启_下一步">
                            <Button
                                type="primary"
                                size="large"
                                block
                                onClick={() => {
                                    navigate('../4/verify', {
                                        state: locationState
                                    });
                                }}>
                                {__('下一步')}
                            </Button>
                        </Track>
                    </CardButtonWrap>
                </div>
            </>
        );
    };

    return <div className="install-step install-step-bind">{render()}</div>;
};

export default Bind;
